//@ts-nocheck
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Stack,
  HStack,
  Text,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import React from "react";
import { object, string, number, array } from "yup";
import { FFormContext } from "../../../primitives/forms/FormField";
import { FFormField } from "../../../primitives/landing-pages";
import {
  arrayToString,
  scrollToId,
  scrollToTop,
} from "../../../utils/functions";
import _locationInfoData from "../../../tutor-revamp/formData/locationInfo.json";
import {
  FullGetMapProps,
  Geolocation,
  AutocompleteFFormField,
} from "./components";

function formatOptions(options: any[] = []) {
  if (Array.isArray(options)) {
    return options.map((item) => ({ label: item, value: item }));
  }
  return [];
}
type LabelValueType = {
  label: string;
  value: string;
};
type LocationFormComponentProps = {
  header: React.ReactNode;
  countryOptions: Array<LabelValueType>;
  countryOnChange: (v: any, form: any) => void;
  stateOptions: Array<LabelValueType>;
  stateOnChange: (v: any, form: any) => void;
  isCountrySupported: boolean;
  regionLabel: string;
  regionOptions: Array<LabelValueType>;
  regionOnChange: (v: any, form: any) => void;
  vicinityLabel: string;
  autocomplete?: boolean;
  addressOnChange: (v: any, form: any) => void;
  countryCode: string;
  addressHelpText: string;
  country: string;
  supportedCountryOptions: Array<LabelValueType>;
  lessonTypeOptions: Array<LabelValueType>;
  errorMessage: React.ReactNode;
  submitButton: React.ReactNode;
  isLiteTutor?: boolean;
  lessonType: {
    heading?: string;
    description?: string;
  };
};
const LocationFormComponent: React.FC<LocationFormComponentProps> = ({
  header,
  countryOptions = [],
  countryOnChange,
  stateOptions,
  stateOnChange,
  isCountrySupported,
  regionLabel,
  regionOptions,
  regionOnChange,
  vicinityLabel,
  autocomplete,
  addressOnChange,
  countryCode,
  addressHelpText,
  lessonType,
  country,
  supportedCountryOptions,
  lessonTypeOptions,
  errorMessage,
  isLiteTutor,
  submitButton,
}) => {
  return (
    <Stack spacing={6} className="Address-section">
      {header}
      <Flex direction={["column", "row"]} justify="space-between">
        <FFormField
          name="country"
          type="select"
          isDisabled={isLiteTutor}
          options={countryOptions}
          onChange={countryOnChange}
        />

        <Box width={6} height={6} />
        <FFormField
          name="state"
          type="select"
          isDisabled={isLiteTutor}
          options={stateOptions}
          onChange={stateOnChange}
        />
      </Flex>
      {isCountrySupported ? (
        <>
          <Flex direction={["column", "row"]} justify="space-between">
            <FFormField
              name="region"
              type="select"
              label={regionLabel}
              options={regionOptions}
              onChange={regionOnChange}
            />

            <Box width={6} height={6} />
            <FFormField name="vicinity" label={vicinityLabel} />
          </Flex>
          {autocomplete ? (
            <AutocompleteFFormField
              name="address"
              onChange={addressOnChange}
              countryCode={countryCode}
              helpText={addressHelpText}
            />
          ) : (
            <FFormField name="address" helpText={addressHelpText} />
          )}
        </>
      ) : null}
    </Stack>
  );
};

const ContainerElement: React.FC<{
  formRender?: any;
  children: any;
  displayMap?: boolean;
  hide?: boolean;
}> = ({ children, formRender, displayMap, hide }) => {
  return (
    <Flex flexDirection={"column"}>
      {formRender}
      <Center
        width="full"
        rounded="lg"
        overflow="hidden"
        mt={hide ? 0 : 5}
        h={hide ? 0 : { base: "240px", md: "360px" }}
        borderWidth={hide ? 0 : "sm"}
        borderColor="green.200"
        shadow="base"
      >
        {displayMap ? children : null}
      </Center>
    </Flex>
  );
};

interface LocationFormWithMapProps
  extends Omit<LocationFormComponentProps, "addressOnChange"> {
  setFieldValue: any;
  displayMap?: boolean;
  defaultCoordinates?: {
    latitude?: number;
    longitude?: number;
  };
}

const LocationFormWithMap: React.FC<LocationFormWithMapProps> = ({
  setFieldValue,
  displayMap,
  defaultCoordinates,
  ...rest
}) => {
  const [hide, setHide] = React.useState(
    !(defaultCoordinates?.latitude && defaultCoordinates?.longitude)
  );
  const shouldHide = rest.isCountrySupported ? hide : true;
  console.log(defaultCoordinates);
  console.log("OPTIONS", rest.lessonTypeOptions);
  return (
    <>
      <Geolocation
        containerElement={(displayMap, children) => {
          return (
            <ContainerElement
              {...{
                displayMap,
                formRender: children,
                // hide: shouldHide,
                hide: true,
              }}
            ></ContainerElement>
          );
        }}
        mapElement={
          <Box
            className="mapper"
            w={"100%"}
            h={shouldHide ? 0 : "400px"}
            alignSelf="center"
          />
        }
        onDrageUpdate={(r) => {
          setFieldValue(
            {
              latitude: r.latitude,
              longitude: r.longitude,
              address: r.address,
            },
            r
          );
        }}
        displayMap={displayMap}
        defaultCoordinate={defaultCoordinates}
      >
        {({
          updateStateAndVicinity,
          location,
          setLocation,
        }: FullGetMapProps) => {
          return (
            <LocationFormComponent
              {...rest}
              countryOnChange={(v, form) => {
                rest.countryOnChange(v, form);
                setLocation({
                  ...location,
                  country: v,
                  state: "",
                  region: "",
                  vicinity: "",
                });
              }}
              stateOnChange={(v, form) => {
                rest.stateOnChange(v, form);
                setLocation({
                  state: v,
                });
              }}
              regionOnChange={(v, form) => {
                rest.regionOnChange(v, form);
                setLocation({
                  region: v,
                });
              }}
              autocomplete={true}
              addressOnChange={(p: any) => {
                setHide(false);
                const newLocations = updateStateAndVicinity(p);
                console.log(newLocations);
                let newR = {};
                [
                  "address",
                  "latitude",
                  "longitude",
                  // "vicinity", "state"
                ].forEach((key) => {
                  if (newLocations[key]) {
                    newR[key] = newLocations[key];
                  }
                });
                setFieldValue(newR, newLocations);
              }}
            />
          );
        }}
      </Geolocation>
      {rest.isCountrySupported ? (
        <>
          <Box py={{ base: 10, md: 12 }}>
            <Divider borderColor="neutral.500" />
          </Box>
          <Field name="lessonType">
            {({ field, form }: { field: any; form: any }) => (
              <Stack spacing={8}>
                <Stack>
                  <Text fontSize="2xl" fontWeight="bold">
                    {rest.lessonType.heading}
                  </Text>
                  <Text color="gray.700">{rest.lessonType.description}</Text>
                  {/* {rest.isLiteTutor && (
                    <Box pb={3} px={{ base: 5, md: 0 }}>
                      <Alert
                        status={"warning"}
                        variant="subtle"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                        height="200px"
                        rounded="xl"
                      >
                        <AlertIcon boxSize="40px" mr={0} />
                        <AlertTitle mt={4} mb={1} fontSize="lg">
                          Online not supported
                        </AlertTitle>
                        <AlertDescription maxWidth="sm">
                          Only physical, in-person lessons are supported for
                          Lite tutoring
                        </AlertDescription>
                      </Alert>
                    </Box>
                  )} */}
                </Stack>
                <HStack align="flex-end">
                  <Box>
                    <FFormField
                      name="lessonType"
                      type="checkbox"
                      isDisabled={rest.isLiteTutor}
                      checkboxSpacing={(i) => ({ ml: i > 0 ? 8 : 0 })}
                      options={[
                        {
                          label: rest.lessonTypeOptions[0].label,
                          value: rest.lessonTypeOptions[0].value,
                        },
                      ]}
                    />
                  </Box>
                  <Box>
                    <FFormField
                      name="lessonType"
                      type="checkbox"
                      checkboxSpacing={(i) => ({ ml: i > 0 ? 8 : 0 })}
                      options={[
                        {
                          label: rest.lessonTypeOptions[1].label,
                          value: rest.lessonTypeOptions[1].value,
                        },
                      ]}
                      hideLabel={true}
                    />
                  </Box>
                </HStack>
              </Stack>
            )}
          </Field>
        </>
      ) : rest.country !== "" ? (
        <Box>
          {rest.errorMessage}
          <Box width={6} height={6} />
          <FFormField
            name="supportedCountryAccount"
            type="select"
            options={rest.supportedCountryOptions}
          />
        </Box>
      ) : null}

      {rest.submitButton}
    </>
  );
};

type RawLocationInfoFormProps = {
  onSubmit: any;
  initialValues?: {
    state: string;
    country: string;
    region: string;
    vicinity: string;
    address: string;
    latitude: number;
    longitude: number;
    supportedCountryAccount: string;
  };
  inSupportedCountry: (country: string) => boolean;
  countryOptions?: any[];
  stateOptions?: (country?: string) => any[];
  regionOptions?: (state?: string) => any[];
  supportedCountries?: string[];
  locationInfoData?: any;
  getCountryCode: (country: string) => string | undefined;
  displayMap?: boolean;
  geoData?: any;
  lessonTypeOptions?: any[];
  defaultCountry?: string;
  isLiteTutor?: boolean;
  liteLocation?: {
    state: string;
    country: string;
    regions: string[];
  };

  [key: string]: any;
};
const RawLocationInfoForm: React.FC<RawLocationInfoFormProps> = ({
  initialValues = {
    state: "",
    country: "",
    region: "",
    vicinity: "",
    address: "",
    supportedCountryAccount: "",
  },
  inSupportedCountry,
  countryOptions = [],
  stateOptions = () => [],
  regionOptions = () => [],
  supportedCountries = [],
  onSubmit,
  loading,
  innerRef,
  buttonProps = {},
  locationInfoData = _locationInfoData,
  getCountryCode,
  displayMap,
  geoData,
  defaultCountry,
  lessonTypeOptions = [],
  liteLocation,
  isLiteTutor,
}) => {
  let [countryData, setCountryData] = React.useState<any>({
    state: liteLocation?.state || initialValues.state,
    country: liteLocation?.country || initialValues.country || defaultCountry,
    region: liteLocation?.region || initialValues.region,
  });
  const [locationData, setLocationData] = React.useState<any>(geoData);
  const countryCode = getCountryCode(countryData.country) || "NG";

  function onUpdateCountryData(key, value: string) {
    setCountryData({ ...countryData, [key]: value });
  }
  function resetCountryData(country: string) {
    setCountryData({
      ...countryData,
      country,
      state: "",
      region: "",
    });
  }
  const {
    formTitle,
    errorMessage,
    placeholders,
    validationData,
    buttonText,
    displayHeader = true,
  } = locationInfoData;
  const validationArray = Object.values(countryData).map((o) =>
    (o as string)?.toLowerCase()?.trim()
  );
  React.useEffect(() => scrollToTop(), []);

  const [showFormError, setShowFormError] = React.useState(false);

  const countryValidate =
    (key: string, callback?: any, skipRequired = false, falseCallback?: any) =>
    (country, schema) => {
      let condition = inSupportedCountry(country);
      if (callback) {
        return condition
          ? callback(
              skipRequired
                ? schema
                : schema.required(validationData[key].required)
            )
          : falseCallback
            ? falseCallback(schema)
            : schema;
      }
      return condition
        ? schema.required(validationData[key].required)
        : falseCallback
          ? falseCallback(schema)
          : schema;
    };
  let supportedCountrySchema = object().shape({
    latitude: number(),
    longitude: number(),
    country: string().required(validationData.country.required),
    state: string().required(validationData.state.required),
    region: string().when("country", countryValidate("region")),
    vicinity: string()
      .trim()
      .when(
        "country",
        countryValidate("vicinity", (x) =>
          x.test("vicinity", validationData.vicinity.test, (value) => {
            if (validationArray.every(Boolean) && value) {
              return !validationArray.includes(value.trim().toLowerCase());
            }
          })
        )
      ),
    address: string()
      .trim()
      .when(
        ["latitude", "longitude", "country"],
        (latitude, longitude, country, schema) => {
          let sCountry = inSupportedCountry(country);
          // let condition = Boolean(latitude) && Boolean(longitude);
          if (!sCountry) {
            return schema;
          }
          // return condition
          //   ?
          return schema.required(validationData.address.required);
          // : schema.test(
          //   "address",
          //   "We couldn't geocode your address. Please select from the list.",
          //   (value) => {
          //     return condition;
          //   }
          // );
        }
      ),
    lessonType: array()
      .of(string())
      .when(
        "country",
        countryValidate(
          "lessonType",
          (x) => x.min(1, validationData.lessonType.minimum),
          true
        )
      ),
    supportedCountryAccount: string().when("country", {
      is: (country: any) => inSupportedCountry(country),
      then: string(),
      otherwise: string().required(),
    }),
  });

  const validationSchema = supportedCountrySchema;

  const onSubmitClick = (errors = {}) => {
    if (errors) {
      console.log(errors);
      if (Object.values(errors).length) {
        setShowFormError(true);
        scrollToId("form-header-section");
      } else {
        setShowFormError(false);
      }
    }
  };
  const locationRegionOptions =
    liteLocation?.regions || regionOptions(countryData.state);
  return (
    <Formik
      validationSchema={validationSchema}
      enableReinitialize
      initialValues={{
        ...initialValues,
        country: liteLocation?.country
          ? liteLocation.country
          : initialValues.country || defaultCountry,
        state: liteLocation?.state ? liteLocation.state : initialValues.state,
        region: liteLocation?.region || initialValues.region,
        lessonType: isLiteTutor ? ["physical"] : initialValues.lessonType,
      }}
      ref={innerRef}
      onSubmit={(values) => {
        let newValues = !inSupportedCountry(values.country)
          ? {
              country: values.country,
              state: values.state,
              region: "",
              vicinity: "",
              address: "",
              latitude: undefined,
              longitude: undefined,
              supportedCountryAccount: values.supportedCountryAccount,
            }
          : { ...values, supportedCountryAccount: values.country };
        onSubmit(newValues, locationData);
      }}
    >
      {({ handleSubmit, values, errors, setFieldValue, setValues }) => {
        let isCountrySupported = inSupportedCountry(values.country);
        return (
          <form
            onSubmit={(value) => {
              handleSubmit(value);
              onSubmitClick(errors);
            }}
          >
            <LocationFormWithMap
              lessonTypeOptions={lessonTypeOptions}
              lessonType={placeholders.lessonType}
              defaultCoordinates={{
                latitude: initialValues.latitude,
                longitude: initialValues.longitude,
              }}
              displayMap={displayMap}
              header={
                <>
                  {displayHeader && (
                    <Stack spacing={4} id="form-header-section" mb={4}>
                      <Text
                        fontWeight="bold"
                        lineHeight="shorter"
                        fontSize={["3xl", "4xl"]}
                      >
                        {formTitle.header}
                      </Text>
                      <Text color="gray.700">{formTitle.subHeader}</Text>
                      {showFormError && (
                        <Box pt={2}>
                          <Alert rounded="lg" status="error">
                            <AlertIcon />
                            {formTitle.errorMessage}
                          </Alert>
                        </Box>
                      )}
                    </Stack>
                  )}
                </>
              }
              countryOptions={formatOptions(countryOptions)}
              countryOnChange={(v: any, form: any) => {
                resetCountryData(v);
                ["state", "region", "vicinity", "address"].forEach((key) => {
                  form.setFieldValue(key, "");
                });
                if (!inSupportedCountry(v)) {
                  form.setFieldValue("lessonType", ["online"]);
                }
              }}
              stateOptions={formatOptions(stateOptions(countryData.country))}
              stateOnChange={(v: any, form: any) => {
                form.setFieldValue("vicinity", "");
                form.setFieldValue("region", "");
                onUpdateCountryData("state", v);
              }}
              isCountrySupported={isCountrySupported}
              regionLabel={
                countryData.state
                  ? `${placeholders.region.labelWithState} ${countryData.state}?`
                  : `${placeholders.region.labelWithoutState}`
              }
              regionOnChange={(v: any, form: any) => {
                onUpdateCountryData("region", v);
              }}
              isLiteTutor={isLiteTutor}
              regionOptions={formatOptions(locationRegionOptions)}
              vicinityLabel={
                countryData.region
                  ? `${placeholders.vicinity.labelWithRegion} ${countryData.region}?`
                  : `${placeholders.vicinity.labelWithoutRegion}`
              }
              setFieldValue={(r: any, locationObj: any) => {
                Object.keys(r).forEach((key) => {
                  setFieldValue(key, r[key]);
                });
                setLocationData(locationObj);
              }}
              countryCode={countryCode.toLowerCase()}
              addressHelpText={placeholders.address.helpText}
              country={values.country}
              supportedCountryOptions={formatOptions(supportedCountries)}
              errorMessage={
                <Alert
                  mt={5}
                  rounded="sm"
                  variant="left-accent"
                  status="warning"
                >
                  <AlertIcon />
                  {errorMessage}
                  {arrayToString(supportedCountries, "or")}.
                </Alert>
              }
              submitButton={
                <Box pt={[10, 16]} width="full">
                  <Button
                    type="submit"
                    size="lg"
                    isFullWidth
                    colorScheme="blue"
                    isLoading={loading}
                    loadingText={buttonText.loadingText}
                    {...buttonProps}
                  >
                    {buttonText.saveAndContinue}
                  </Button>
                </Box>
              }
            />
          </form>
        );
      }}
    </Formik>
  );
};

export interface LocationInfoPageType extends RawLocationInfoFormProps {
  formHeader: string;
  formSummary: string[];
  loading: boolean;
  label?: string;
  countries: any[];
  supportedCountryAccount?: string;
  onSubmit: (params?: any, geocode?: any) => any;
  lockedDescription: string;

  [key: string]: any;
}

export const LocationInfoForm: React.FC<LocationInfoPageType> = ({
  onSubmit,
  supportedCountryAccount,
  loading,
  ...rest
}) => {
  return (
    <FFormContext.Provider
      value={{ placeholders: _locationInfoData.placeholders }}
    >
      <RawLocationInfoForm
        key={rest.initialValues?.address ?? ""}
        loading={loading}
        onSubmit={onSubmit}
        supportedCountryAccount={supportedCountryAccount}
        {...rest}
      />
    </FFormContext.Provider>
  );
};
